import { Component } from '@angular/core';
import { MessagingService } from './messaging.service';
import { Observable } from 'rxjs';
import { LabOrderValidationError } from '../../../api/lab-order/model/labOrderValidationError';

@Component({
  selector: 'app-general-message',
  templateUrl: './general-message.component.html',
  styleUrls: ['./general-message.component.scss'],
})
export class GeneralMessageComponent {
  message$?: Observable<{
    text: string;
    type: string;
    errors?: LabOrderValidationError[];
  } | null>;

  constructor(private readonly messagingService: MessagingService) {
    this.message$ = this.messagingService.messages$;
  }

  hideElabAlert() {
    this.messagingService.clearMessages();
  }

  getErrorMessage(error: LabOrderValidationError): string | undefined {
    return error.errorNumber?.includes('1024') ? 'Please select a Doctor' : error.message;
  }
}
